import { render } from "./trust-tabs.vue?vue&type=template&id=335abab1&scoped=true"
import script from "./trust-tabs.vue?vue&type=script&lang=js"
export * from "./trust-tabs.vue?vue&type=script&lang=js"

import "./trust-tabs.vue?vue&type=style&index=0&id=335abab1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335abab1"]])

export default __exports__